<template>
  <div :class="{'nestable-table': true, 'nestable-table-striped': stripedRows, 'nestable-table-hover': hoverRows, 'nestable-table-bordered-rows': borderedRows}">
    <div class="nestable-table-header-row border-bottom">
      <div v-for="(column, index) in columns" :key="index" class="nestable-table-header-cell" :style="{'flex-basis': column.width}">
        {{column.title}}
      </div>
    </div>
    <NestableTableList :rows="rowList" @update="listUpdated" :editing="editing" :childListProperty="childListProperty">
      <template v-for="slot in Object.keys($scopedSlots)" v-slot:[slot]="scope">
        <slot :name="slot" v-bind="scope"/>
      </template>
    </NestableTableList>
    <div class="nestable-table-body" v-if="rowList.length == 0">
      <p class="font-italic text-center text-muted">
        <slot name="empty" />
      </p>
    </div>
  </div>
</template>

<style>
.nestable-table-flip-list-move {
  transition: transform 0.25s;
}
.nestable-table-header-row {
  display:flex;
  flex-direction:row;
}
.nestable-table-header-cell {
  font-weight: bold;
  flex-grow: 1;
  padding: 8px;
}
.nestable-table-row-children {
  padding-left: 10px;
}
.nestable-table-row {
  display:flex;
  flex-direction:row;
}
.nestable-table-row-striped .nestable-table-cell {
  background-color: rgba(0,0,0,.05);
}
.nestable-table-bordered-rows .nestable-table-row {
  border-bottom: 1px solid #e7eaec;
}
.nestable-table-body > div > .nestable-table-row > .nestable-table-cell {
  line-height: 1.42857;
  flex-grow: 1;
  text-align:left;
  padding: 8px;
}
.nestable-table .nestable-table-body .nestable-table-row .nestable-table-cell {
  min-height: 46px;
  vertical-align: middle;
  display: flex;
  align-items: center;
}
.nestable-table-cell-contents {
  flex: 1;
}

/* Note: Manually doing alternate striping for nesting */
.nestable-table-striped .nestable-table-body .nestable-table-row.striping-row-odd {
  background-color: rgba(0,0,0,.05);
}
.nestable-table-hover .nestable-table-body .nestable-table-row:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
.nestable-table-indent {
  display: flex;
  flex-basis: content;
  line-height: 1.42857;
  vertical-align: middle;
  align-items: center
}

.nestable-table-row-handle {
  display: flex;
  flex-basis: content;
  line-height: 1.42857;
  vertical-align: middle;
  align-items: center;
  color: #c9cbcc;
  cursor: move;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>

<script>
import _ from 'lodash'

import NestableTableList from '@/components/table/nestableTableList'

export default {
  name: 'NestableTable',
  model: {
    event: 'update'
  },
  components: {
    NestableTableList
  },
  props: {
    columns: Array,
    value: Array,
    editing: Boolean,
    stripedRows: {
      type: Boolean,
      default: false
    },
    hoverRows: {
      type: Boolean,
      default: false
    },
    borderedRows: {
      type: Boolean,
      default: false
    },
    childListProperty: {
      type: String,
      default: 'childItems'
    }
  },
  computed: {
    dragOptions() {
      return {
        ghostClass: "ghost"
      };
    }
  },
  data() {
    return {
      rowList: _.cloneDeep(this.$props.value)
    }
  },
  mounted() {
  },
  watch: {
    value: function(newVal) {
      this.$data.rowList = _.cloneDeep(this.$props.value)
    },
    rowList: function(newVal) {
    }
  },
  methods: {
    listUpdated(evt) {
      this.$data.rowList = evt
      this.$emit('update', this.rowList)
    }
  }
}
</script>